import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "app",
  routes: [
    {
      path: "/",
      name: "home",
      meta: { announcer: "Dashboard " },
      component: () => import("./views/Dashboard.vue"),
    },
    {
      path: "/auth",
      name: "auth",
      meta: { announcer: "Login" },
      component: () => import("./views/Auth.vue"),
    },
    {
      path: "/symptom/:module",
      name: "symptom",
      meta: { announcer: "Page" },
      component: () => import("./views/Symptom.vue"),
    },
    {
      path: "/behavior/:module",
      name: "behavior",
      meta: { announcer: "Page" },
      component: () => import("./views/Behavior.vue"),
    },
    {
      path: "/worksheets",
      name: "worksheets",
      meta: { announcer: "Page" },
      component: () => import("./views/Worksheets.vue"),
    },
  ],
});
